<template>
  <div class="l-main">
    <div class="c-reserve-conf">
      <p class="c-reserve-conf__attend">入力された内容をご確認の上、「上記に同意のうえ送信する」ボタンを押してください。</p>
      <dl class="c-reserve-conf--list">
        <div class="c-reserve-conf--list--item">
          <dt>お名前 / フリガナ</dt><dd>{{data.name}} / {{data.kana}}</dd>
        </div>
        <div class="c-reserve-conf--list--item">
          <dt>メールアドレス</dt><dd>{{data.email}}</dd>
        </div>
        <div class="c-reserve-conf--list--item">
          <dt>電話番号</dt><dd>{{data.tel}}</dd>
        </div>
        <div class="c-reserve-conf--list--item">
          <dt>資料のお届け先 </dt><dd>{{data.pref}}{{data.city}}{{data.building}}</dd>
        </div>
      </dl>
      <common-agree-check v-model="agreeChecked" @clear="agreeTooltip = false" :error="agreeTooltip" class="c-reserve-conf__attend">
        <span class="reservation-agree">
          個人情報保護方針と会員規約に同意する
        </span>
      </common-agree-check>
      <div class="c-reserve-conf__term">
        <a target="_blank" href="https://ki-group.co.jp/policy/">
          <img :src="require('@/assets/icon-document.png')">
          個人情報保護方針（プライパシーポリシー）
        </a>
        <a target="_blank" href="https://ki-group.co.jp/member/agreement/">
          <img :src="require('@/assets/icon-document.png')">
          会員規約（利用規約）
        </a>
      </div>
    </div>
    <div class="c-reserve-form--button">
      <button v-if="isLoading" @click="toForm" class="c-reserve-form--button__back disabled-button" >
        修正する
      </button>
      <button v-else @click="toForm" class="c-reserve-form--button__back" >
        修正する
      </button>
      <button v-if="isLoading" disabled class="c-reserve-form--button__confirm disabled-button" @click="toComp">
        送信中です・・・
      </button>
      <button v-else-if="!agreeChecked" class="c-reserve-form--button__confirm disabled-button" @click="showAgreeTooltip" >
        上記に同意の上送信する
      </button>
      <button v-else class="c-reserve-form--button__confirm" @click="submit" :disabled="!agreeChecked">
        上記に同意の上送信する
      </button>
    </div>
    <p v-if="err.isErr" class="p-errmsg">
      <span>
        <img src="@/assets/attention.png" alt="エラー" width="22" height="22" />
      </span>
      {{ err.msg }}
    </p>
  </div>
</template>

<script>
import MobileMixin from '@/plugins/isMobile';
import CommonAgreeCheck from '@/components/parts/CommonAgreeCheck';

export default {
  name: 'DocumentRequestConfirm',
  mixins: [MobileMixin],
  props: ['page', 'data', 'sendMail', 'isLoading', 'err'],
  components: {
    CommonAgreeCheck,
  },
  data() {
    return {
      agreeChecked: false,
      agreeTooltip: false,
    };
  },
  computed: {
    isPageChild: {
      get() {
        return this.page;
      },
      set(page) {
        this.$emit('input', page);
      },
    },
  },
  created() {
  },
  mounted() {
    this.$SmoothScroll(
      document.querySelector('body'),
      400,
      null,
      null,
      'y',
    );
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
    toForm() {
      this.isPageChild = 'form';
    },
    hideAgreeTooltip() {
      this.agreeTooltip = false;
    },
    showAgreeTooltip() {
      this.agreeTooltip = true;
    },
    toComp() {
      this.sendMail();
      this.isPageChild = 'comp';
    },
  },
};
</script>

<style scoped lang="scss">
@charset "UTF-8";
.l-main {
  padding: 30px 0;
  .c-reserve-conf {
    margin:auto;
    width:100%;
    max-width:680px;
    &__attend {
      width:100%;
      text-align: center;
      font-weight: bold;
      color:#E83532;
      margin:0 auto 30px;
    }
    &__attend:nth-child(3) {
      margin-top:50px;
    }
    &--list{
      width:100%;
      &--item {
        display:flex;
        margin-top: 1px;
        dt {
          width:100%;
          max-width:200px;
          background-color: #F6F6F6;
          border: 1px solid #FFF;
          padding:10px;
          line-height:1.5;
        }
        dd {
          width:100%;
          max-width:480px;
          height:100%;
          min-height:37px;
          padding:10px;
          line-height:1.5;
        }
      }
    }
    &__term {
      display:flex;
      justify-content: center;;
      a {
        display:block;
        img {
          vertical-align: sub;
          width: 24px;
          height: 24px;
        }
      }
      a:nth-child(2){
        margin-left:10px;
      }
    }
  }
  .c-reserve-form {
    &--button {
      display:flex;
      justify-content: center;
      align-items: center;
      margin-top:50px;
      button {
        height: 55px;
        border-radius: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight:bold;
      }
      &__back {
        width:152px;
        border: 1px solid #CCC;
        background-color:#FFF;
        margin-right: 26px;
      }
      &__confirm {
        color: #FFF;
        width: 264px;
        background-color: #E83532;
      }
    }
  }
}

@media screen and (max-width: 639px) {
  .l-main {
    padding: 30px 0 0;
    background: #fafafa;
    .c-reserve-conf {
      width:100%;
      max-width:680px;
      &__attend {
        text-align: left;
        line-height: 1.5em;
      }
      &--list{
        width:100%;
        &--item {
          display:flex;
          flex-wrap: wrap;
          dt {
            width:100%;
            max-width:100%;
            border:0;
          }
          dd {
            width:100%;
            max-width:100%;
          }
        }
      }
      &__term {
        flex-wrap: wrap;
        justify-content: left;
        a:nth-child(2){
          margin-top:10px;
          margin-left:0px;
        }
      }
    }
    .c-reserve-form {

      &--button {
        flex-wrap:wrap-reverse;
        margin-top:30px;
        margin-bottom:80px;

        button {
          width:100%;
        }
        &__back {
          position: relative;
          margin-top:10px;
          margin-right: 0px;
        }
      }
    }
  }
}
.disabled-button {
  opacity: 0.6;
  cursor: default;
}

.reservation-agree {
  color: #666;
}
</style>
